import { SvgIcon, SvgIconProps } from '../../../icons/SvgIcon';

export const HeartIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props}>
      <path
        d="M2 7.5C2 12.1812 7.79543 16.138 9.52092 17.2124C9.81741 17.397 10.1826 17.397 10.4791 17.2124C12.2046 16.138 18 12.1812 18 7.5C18 4.73858 15.7614 2.5 13 2.5C11.8744 2.5 10.8357 2.87194 10 3.49963C9.16434 2.87194 8.12561 2.5 7 2.5C4.23858 2.5 2 4.73858 2 7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
    </SvgIcon>
  );
};
